import { useState, useEffect, useRef, useMemo, useContext } from "react";
import { useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import toast from "react-hot-toast";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import Skeleton from "@mui/material/Skeleton";
import UploadGalleryModal from "pages/de/portfolio/components/UploadGalleryModal";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";

import ProductCard from "pages/de/portfolio/components/ProductCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Empty } from "antd";

import api from "services/api";

const FeaturedGalleryList = ({ slot = "gallery_0" }) => {
  const [userData, setUserData] = useState({}); //retrieve user data by give handle
  const [uploadGalleryVisible, setUploadGalleryVisible] = useState(false);
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);

  const [imgsViewerCurrent, setImgsViewerCurrent] = useState(0);

  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  const params = useParams();
  const handle = params?.handle;

  useEffect(() => {
    handleRefresh();
  }, [handle]);

  let portfolioData = account?.metadata?.portfolio_content || {};
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
  }

  const gallery = portfolioData[slot] || [];

  const handleShowEdit = (e) => {
    setUploadGalleryVisible(true);
  };

  const handleRefresh = async () => {
    if (handle) {
      const userProfile = await api.users.retrieve(handle);
      if (userProfile?.data?.user) {
        setUserData(userProfile?.data?.user);
      }
    } else {
      try {
        const mySelf = await account.handleRefresh();
        setUserData(mySelf?.data?.user || {});
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleClickImage = (e, item, index) => {
    e.preventDefault();
    e.stopPropagation();
    let img = item?.img || {};
    if (!img?.type.includes("video")) {
      setImgsViewerVisible(true);
      setImgsViewerCurrent(index);
    }
  };

  return (
    <SuiBox sx={{ px: 2 }}>
      {gallery.length > 0 ? (
        <ResponsiveMasonry columnsCountBreakPoints={{ 250: 1, 650: 2, 1050: 3, 1400: 4 }}>
          <Masonry>
            {gallery.map((item, index) => {
              return (
                <SuiBox key={index}>
                  <div
                    className="mx-2 my-2"
                    style={{
                      overflow: "hidden",
                    }}
                  >
                    <ProductCard
                      index={index}
                      product={item}
                      imageOnly={true}
                      handleClick={(e) => handleClickImage(e, item, index)}
                      editable={handle ? false : true}
                      slot="gallery_0"
                      handleRefresh={handleRefresh}
                      handleEdit={handleShowEdit}
                      isOriginalSize
                      height={260}
                      width={240}
                      sx={{ height: 260, width: "100%", maxHeight: 320 }}
                      videoProps={{ height: 260, width: "100%", maxHeight: 320 }}
                    />
                  </div>
                </SuiBox>
              );
            })}
          </Masonry>
        </ResponsiveMasonry>
      ) : (
        <SuiBox my={4}>
          <Empty />
        </SuiBox>
      )}

      {uploadGalleryVisible ? (
        <UploadGalleryModal
          handleClose={() => setUploadGalleryVisible(false)}
          visible={uploadGalleryVisible}
          handleRefresh={() => {
            handleRefresh();
          }}
        />
      ) : null}

      {gallery.length > 0 ? (
        <Lightbox
          open={imgsViewerVisible}
          close={() => setImgsViewerVisible(false)}
          slides={gallery
            .filter((p) => !p?.img?.type.includes("video"))
            .map((p, inx) => ({
              src: p?.img?.url,
              id: inx,
            }))}
          plugins={[Zoom, Download]}
          zoom={{ maxZoomPixelRatio: 3 }}
          index={imgsViewerCurrent}
        />
      ) : null}
    </SuiBox>
  );
};

export default FeaturedGalleryList;
